export class Result
{
    result: number

    public static isKind ( result: any )
    {
        return  result          != undefined    &&
                result.result   != undefined    
    }

} 